import k from './k'

import zero from './scenes/zero'
import one from './scenes/one'
import two from './scenes/two'
import three from './scenes/three'
import four from './scenes/four'
import five from './scenes/five'
import six from './scenes/six'
import seven from './scenes/seven'
import gameOver from './scenes/gameOver'

k.loadRoot('./')

k.setCursor('none')

k.loadFont('pixel', 'fonts/pixel.ttf')

k.loadSound('music', 'sounds/space_elevator.mp3')
k.play('music', {
  volume: 0.4,
  loop: true,
  speed: 1
})

// scenes
k.scene('zero', () => zero())
k.scene('one', () => one())
k.scene('two', () => two())
k.scene('three', () => three())
k.scene('four', () => four())
k.scene('five', () => five())
k.scene('six', () => six())
k.scene('seven', () => seven())
k.scene('gameOver', () => gameOver())

k.go('zero')
